// @flow

import _ from 'lodash';

import ArrayUtils from '../../utils/ArrayUtils';

import ApiObject from '../ApiObject';
import OrderProductOptionValue from './OrderProductOptionValue';

import ProductOption from '../menu/ProductOption';

export default class OrderProductOption extends ApiObject {

  id: string;

  name: string;

  values: Array<OrderProductOptionValue> = [];

  postJsonAssignation(data: Object) {
    this.values = [];
    _.each(data.values, (valueData) => {
      const orderProductOptionValue:OrderProductOptionValue = new OrderProductOptionValue();
      orderProductOptionValue.fromJson(valueData);
      this.values.push(orderProductOptionValue);
    });
  }

  equals(other: OrderProductOption): boolean {
    return this.id === other.id && this.valuesEquals(other.values);
  }

  valuesEquals(otherValues: Array<OrderProductOptionValue>) {
    // TODO: Handle not same order.
    if (otherValues.length !== this.values.length) {
      return false;
    }
    for (let i = 0; i < this.values.length; i++) {
      if (!this.values[i].equals(otherValues[i])) {
        return false;
      }
    }

    return true;
  }

  //
  //
  //

  getDescription(): string {
    let description = '';
    const separator = ', ';

    _.each(this.values, (optionValue: OrderProductOptionValue) => {
      description += optionValue.name + separator;
    });

    // remove last separator.
    return description.substring(0, description.length - separator.length);
  }

  getQuantity(): number {
    return this.values.length;
  }

  getTotalAdditionnalPrice() {
    return this.getTotalValuesAdditionnalPrice();
  }

  getTotalValuesAdditionnalPrice() {
    let price = 0;
    _.each(this.values, (orderProductOptionValue: OrderProductOptionValue) => {
      price += orderProductOptionValue.getTotalAdditionnalPrice();
    });

    return price;
  }

  getValuesWithQuantities() {
    // contains the list of products, with the quantity for each
    let valuesWithQuantities = [];

    _.each(this.values, (orderProductOptionValue: OrderProductOptionValue, index) => {
      // search for an already set orderProduct.
      const found = _.find(valuesWithQuantities, (valueWithQuantity) => {
        const optionValueToCompare:OrderProductOptionValue = valueWithQuantity.orderProductOptionValue;

        return optionValueToCompare.equals(orderProductOptionValue);
      });

      // not found
      if (_.isUndefined(found)) {
        valuesWithQuantities.push({
          quantity: 1,
          orderProductOptionValue
        });
      } else {
        // update array
        found.quantity++;
      }
    });

    return valuesWithQuantities;
  }

  haveValueWithId(valueId: string): boolean {
    return ArrayUtils.exists(this.values, { 'id': valueId });
  }

  haveValue(optionValue: OrderProductOptionValue): boolean {
    return ArrayUtils.exists(this.values, { 'id': optionValue.id });
  }

  //
  //
  //

  toggleOptionValue(optionValue: OrderProductOptionValue) {
    if (this.haveValue(optionValue)) {
      this.deleteValue(optionValue);
    } else {
      this.addValue(optionValue);
    }
  }

  addValue(optionValue: OrderProductOptionValue) {
    this.values.push(optionValue);
  }

  deleteValue(optionValue: OrderProductOptionValue) {
    this.values = ArrayUtils.removeObject(this.values, { 'id': optionValue.id });
  }

  replaceOlderValueWith(optionValue: OrderProductOptionValue) {
    // TODO: test
    this.deleteValue(this.values[0]);
    this.addValue(optionValue);
  }

  fromProductOption(option: ProductOption) {
    this.id = option.id;
    this.name = option.name;
  }

}
